import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { overdraftDetail } from '../overdraft-detailed-v2-config/base';
import { statements } from '../statements-config/base';
import { roundingSavings } from '../round-up-savings-config/base';
import { settingsDetails } from '../settings-details-config/base';

export const currentAccount: CurrentAccountConfig = {
    enabled: true,
    sCreditlineOverdraft: false,
    sCreditline: false,
    overdraftProgress: {
        enabled: false,
    },
    overdraft: false,
    overdraftDetail,
    paymentsEnforced: false,
    statements,
    standingOrderDispoModel: false,
    roundingSavings,
    sepaMandatesRead: {
        enabled: true,
    },
    accountAddress: {
        enabled: true,
    },
    billPayments: {
        enabled: false,
    },
    /** Current account settings page config */
    settingsDetails,
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: false,
            showDisposableAndOverdraftAmount: false,
            showDisposableAndBalanceAmounts: false,
            showDisposableAndOwnResourcesAmounts: false,
            showOwnResourcesWithOverdraftAndDisposableAmounts: false,
        },
    },
    instantPaymentLimit: {
        showOwnTransferMessage: false,
        showOrderMessage: false,
    },
    dashboard: {
        separateOverdraftAndDisposableDisplay: false,
    },
};
